import { render, staticRenderFns } from "./AllowedHashList.vue?vue&type=template&id=72fdf85e&scoped=true&"
import script from "./AllowedHashList.vue?vue&type=script&lang=js&"
export * from "./AllowedHashList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdf85e",
  null
  
)

export default component.exports